import { unreachable } from 'utils/unreachable';
export var SourceType = /*#__PURE__*/ function(SourceType) {
    SourceType["Task"] = "task";
    SourceType["Project"] = "project";
    SourceType["ProjectPhase"] = "project-phase";
    SourceType["Timesheet"] = "timesheet";
    SourceType["User"] = "user";
    SourceType["Phase"] = "phase";
    SourceType["Sprint"] = "sprint";
    SourceType["Company"] = "company";
    SourceType["Role"] = "role";
    SourceType["StarMeta"] = "starmeta";
    SourceType["ActualStarMeta"] = "actualstarmeta";
    SourceType["EstimatedStarMeta"] = "estimatedstarmeta";
    SourceType["Invoice"] = "invoice";
    SourceType["CreditNote"] = "creditnote";
    SourceType["ResourceRequest"] = "resourcerequest";
    SourceType["ResourceAllocation"] = "resource-allocation";
    SourceType["RequestApproval"] = "requestapproval";
    SourceType["Financial"] = "financial";
    SourceType["Formula"] = "formula";
    SourceType["Epic"] = "epic";
    SourceType["Backlog"] = "backlog";
    SourceType["Sheet"] = "sheet";
    SourceType["BillingEvent"] = "billing-event";
    SourceType["Expense"] = "expense";
    SourceType["Policy"] = "policy";
    SourceType["SheetColumn"] = "sheet_column";
    SourceType["ExpenseReport"] = "expense_report";
    SourceType["RevenueEntry"] = "revenue-entry";
    SourceType["ProjectFinancialBudget"] = "project-financial-budget";
    SourceType["ProjectFinancialsBudget"] = "project-financials-budget";
    SourceType["Form"] = "form";
    SourceType["Signal"] = "signal_occurrence";
    SourceType["LeaveMeta"] = "leavemeta";
    SourceType["Email"] = "email";
    return SourceType;
}({});
export var FieldType = /*#__PURE__*/ function(FieldType) {
    FieldType["Boolean"] = "Boolean";
    FieldType["Number"] = "Number";
    FieldType["Text"] = "Text";
    FieldType["MultiLineText"] = "MultiLineText";
    FieldType["Date"] = "Date";
    FieldType["SingleSelect"] = "SingleSelect";
    FieldType["MultiSelect"] = "MultiSelect";
    FieldType["SingleUser"] = "SingleUser";
    FieldType["MultiUser"] = "MultiUser";
    FieldType["Assignee"] = "Assignee";
    FieldType["Estimate"] = "Estimate";
    FieldType["Note"] = "Note";
    return FieldType;
}({});
export var NativeFieldName = /*#__PURE__*/ function(NativeFieldName) {
    NativeFieldName["PhaseName"] = "phaseName";
    return NativeFieldName;
}({});
export const FIELD_ID_ASSIGNEE = -127;
export const UserTypeFields = [
    "SingleUser",
    "MultiUser",
    "Assignee"
];
const calculatedFieldTypeMap = {
    currentPhases: "Text",
    actualStartDate: "Date",
    actualCompletedDate: "Date",
    customerCompanyName: "Text",
    completionPercentage: "Number",
    projectTrackedHours: "Number",
    totalBillableHours: "Number",
    totalNonBillableHours: "Number",
    overallRating: "Number",
    lastMilestoneRating: "Number",
    projectAge: "Number",
    plannedDuration: "Number",
    completedTasks: "Number",
    overdueTasks: "Number",
    blockedTasks: "Number",
    atRiskTasks: "Number",
    approvalPending: "Number"
};
export const filterableFieldType = (field)=>{
    if (field.fieldName === 'assignee') {
        return "Assignee";
    }
    if (field.fieldType === 'ASSIGNEE') {
        return "Assignee";
    }
    if ((field === null || field === void 0 ? void 0 : field.fieldDataType) === 'USER') {
        return (field === null || field === void 0 ? void 0 : field.fieldType) === 'SINGLE_SELECT' ? "SingleUser" : "MultiUser";
    }
    if (field.fieldName === 'estimatedDueDate') {
        return "Estimate";
    }
    if (calculatedFieldTypeMap[field.fieldName]) {
        return calculatedFieldTypeMap[field.fieldName];
    }
    if (field.fieldName === 'projectOwner') {
        return "SingleUser";
    }
    if (field.fieldName === "phaseName") {
        return "Text";
    }
    if (field.fieldName === 'projectFinancialsBudgets') {
        return "MultiSelect";
    }
    const type = field.optionsAvailable ? field.fieldType : field.fieldDataType;
    switch(type){
        case 'BOOLEAN':
            return "Boolean";
        case 'NUMBER':
            return "Number";
        case 'TEXT':
            return "Text";
        case 'MULTI_LINE_TEXT':
            return "MultiLineText";
        case 'DATE':
            return "Date";
        case 'USER':
            return field.fieldType === 'SINGLE_SELECT' ? "SingleUser" : "MultiUser";
        case 'SINGLE_SELECT':
            return "SingleSelect";
        case 'MULTI_SELECT':
            return field.fieldDataType === 'NOTE' ? "Note" : "MultiSelect";
        case 'NOTE':
            return "Note";
        default:
            return unreachable(type);
    }
};
